import { extend } from 'vee-validate'

/**
 * Validates that an input is a valid URL with http or https protocol.
 */
extend('product_url', {
  validate(value) {
    if (!value) return true
    try {
      const url = new URL(value)
      return (url.protocol === 'http:' || url.protocol === 'https:') && url.hostname.includes('.')
    } catch (_) {
      return false
    }
  },
  message: 'Format URL produk tidak valid.',
})

/**
 * Validates thumbnail file format (JPG/PNG) and max size 3 MB.
 * If value is a string (e.g. existing URL on Edit Campaign), it passes.
 */
extend('thumbnail_format_size', {
  validate(val) {
    if (!val) return true
    // If it's an existing URL string (from edit campaign), it's valid
    if (typeof val === 'string' && val.length > 0) return true

    const file = Array.isArray(val) ? val[0] : val
    if (!file || !(file instanceof File)) return true

    const validTypes = ['image/jpeg', 'image/png']
    const hasValidType = validTypes.includes(file.type) || /\.(jpe?g|png)$/i.test(file.name || '')
    const hasValidSize = file.size <= 3 * 1024 * 1024

    return hasValidType && hasValidSize
  },
  message: 'Format harus JPG/PNG maksimal 3 MB.',
})

/**
 * Validates that end date is on or after start date.
 */
extend('after_or_equal_date', {
  params: ['target'],
  validate(value, { target }) {
    if (!value || !target) return true
    const dStart = new Date(target)
    const dEnd = new Date(value)
    dStart.setHours(0, 0, 0, 0)
    dEnd.setHours(0, 0, 0, 0)
    return dEnd.getTime() >= dStart.getTime()
  },
  message: 'End date harus setelah atau sama dengan start date.',
})
